import React from 'react'
import { SvgIcon } from '@material-ui/core'

const Dashboard = (props) => {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="27.75" height="27.75" viewBox="0 0 27.75 27.75">
      <g id="Group_5356" data-name="Group 5356" transform="translate(-1373.625 -161.625)" fill="#fff">
        <path id="Path_12434" data-name="Path 12434" className="cls-1" d="M1387.5 170.2a.75.75 0 0 0-.75.75v7.585a.75.75 0 0 0 1.5 0v-7.585a.75.75 0 0 0-.75-.75z" />
        <path id="Path_12435" data-name="Path 12435" className="cls-1" d="M1382.949 173.233a.75.75 0 0 0-.75.75v6.068a.75.75 0 0 0 1.5 0v-6.068a.75.75 0 0 0-.75-.75z" />
        <path id="Path_12436" data-name="Path 12436" className="cls-1" d="M1392.051 174.75a.75.75 0 0 0-.75.75v4.551a.75.75 0 0 0 1.5 0V175.5a.75.75 0 0 0-.75-.75z" />
        <path id="Path_12437" data-name="Path 12437" className="cls-1" d="M1400.84 170.881a11.706 11.706 0 0 0-8.721-8.722 20.244 20.244 0 0 0-9.238 0 11.709 11.709 0 0 0-8.722 8.722 20.243 20.243 0 0 0 0 9.238 11.709 11.709 0 0 0 8.722 8.722 20.244 20.244 0 0 0 9.238 0 11.706 11.706 0 0 0 8.721-8.722 20.216 20.216 0 0 0 0-9.238zm-9.064 16.5a18.717 18.717 0 0 1-8.552 0 10.2 10.2 0 0 1-7.6-7.6 18.715 18.715 0 0 1 0-8.552 10.2 10.2 0 0 1 7.6-7.6 18.717 18.717 0 0 1 8.552 0 10.2 10.2 0 0 1 7.6 7.6 18.715 18.715 0 0 1 0 8.552 10.2 10.2 0 0 1-7.6 7.599z" />
      </g>
    </SvgIcon>
  )
}

export default Dashboard
